import React from "react";
import Header from "../../common/Header";
import { Tabs } from "antd";

const SheetApprovalComponent = (props) => {
  const { items, alignValue, onChange } = props;
  return (
    <>
      <Header title="Pre-Approved Registration" />

      <div className="permission-container">
        <div className="permission-title">
          <h2>Import and Register Users</h2>
        </div>
        <div className="tabs-container">
          <Tabs
            defaultActiveKey="1"
            items={items}
            onChange={onChange}
            indicator={{
              size: (origin) => origin - 20,
              align: alignValue,
            }}
          />
        </div>
      </div>
    </>
  );
};

export default SheetApprovalComponent;
